import styled from "styled-components";
import {
  adminRoutes,
  physicalCardRoutes,
  financeRoutes,
  marketingRoutes,
  aquaManagerRoutes,
  lwwTicketRoutes
} from "../../config";
import { useUserContext } from "../../contexts/UserContext";
import SidebarItem from "./SidebarItem";

type SideBarProps = {
  onRoute: (route: string) => void;
  activePath: string;
};

const SideBar = ({ onRoute, activePath }: SideBarProps) => {
  const { user } = useUserContext();
  return (
    <SidebarContainer>
      <SidebarLogo
        src={require("../../assets/images/logo-hug.png")}
        alt="logo"
      />
      <SidebarLogoSmall
        src={require("../../assets/images/logo-small.png")}
        alt="logo"
      />
      {Number(user) === 1 && (
        <StyledSidebarComponent>
          {adminRoutes.map((route: any, idx) => (
            <SidebarItem
              key={idx}
              route={route}
              activePath={activePath}
              onRoute={onRoute}
            />
          ))}
        </StyledSidebarComponent>
      )}
      {Number(user) === 2 && (
        <StyledSidebarComponent>
          {physicalCardRoutes.map((route: any, idx: number) => {
            return (
              <SidebarItem
                key={idx}
                route={route}
                activePath={activePath}
                onRoute={onRoute}
              />
            );
          })}
        </StyledSidebarComponent>
      )}
      {Number(user) === 3 && (
        <StyledSidebarComponent>
          {financeRoutes.map((route: any, idx: number) => {
            return (
              <SidebarItem
                key={idx}
                route={route}
                activePath={activePath}
                onRoute={onRoute}
              />
            );
          })}
        </StyledSidebarComponent>
      )}
      {Number(user) === 4 && (
        <StyledSidebarComponent>
          {marketingRoutes.map((route: any, idx: number) => {
            return (
              <SidebarItem
                key={idx}
                route={route}
                activePath={activePath}
                onRoute={onRoute}
              />
            );
          })}
        </StyledSidebarComponent>
      )}
      {Number(user) === 5 && (
        <StyledSidebarComponent>
          {aquaManagerRoutes.map((route: any, idx: number) => {
            return (
              <SidebarItem
                key={idx}
                route={route}
                activePath={activePath}
                onRoute={onRoute}
              />
            );
          })}
        </StyledSidebarComponent>
      )}
      {Number(user) === 6 && (
        <StyledSidebarComponent>
          {lwwTicketRoutes.map((route: any, idx: number) => {
            return (
              <SidebarItem
                key={idx}
                route={route}
                activePath={activePath}
                onRoute={onRoute}
              />
            );
          })}
        </StyledSidebarComponent>
      )}
    </SidebarContainer>
  );
};

const SidebarLogo = styled.img`
  width: 10.5rem;
  align-self: center;
  margin: 2rem 0 0.5rem 0;
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

const SidebarLogoSmall = styled.img`
  display: none;
  @media only screen and (max-width: 1200px) {
    display: block;
    width: 2rem;
    align-self: center;
    margin-top: 1.5rem;
  }
`;

const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const StyledSidebarComponent = styled.ul`
  min-width: 15rem;
  height: calc(100vh - 11.5rem);
  background: black;
  padding: 0;
  padding-left: 1rem;
  padding-top: 1rem;
  list-style-type: none;
  overflow-y: auto;
  @media only screen and (max-width: 1200px) {
    min-width: 3.25rem;
    padding-top: 1rem;
    padding-left: 0.25rem;
  }
  &::-webkit-scrollbar {
    width: 0;
    -webkit-appearance: none;
  }
`;

export default SideBar;
